import { render, staticRenderFns } from "./VirtualStockExpedition.vue?vue&type=template&id=2b58a39a&scoped=true&"
import script from "./VirtualStockExpedition.vue?vue&type=script&lang=js&"
export * from "./VirtualStockExpedition.vue?vue&type=script&lang=js&"
import style0 from "./VirtualStockExpedition.vue?vue&type=style&index=0&id=2b58a39a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b58a39a",
  null
  
)

export default component.exports